import { readNestedBookingRecord } from './nestedBookingRecord';

export function parseGuestBookingsValue(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number(value.trim());
    if (Number.isFinite(parsed) && parsed >= 0) {
      return parsed;
    }
  }
  return undefined;
}

/** Nested `Booking` guest count first, then top-level — matches hydrate / spot-bookings parsing. */
export function readGuestBookingsFromRecord(source: Record<string, unknown>): number | undefined {
  const nested = readNestedBookingRecord(source);
  if (nested) {
    const nestedValue = nested['guest_bookings'] ?? nested['guestBookings'];
    if (nestedValue != null) {
      const nestedParsed = parseGuestBookingsValue(nestedValue);
      if (nestedParsed !== undefined) {
        return nestedParsed;
      }
    }
  }
  return parseGuestBookingsValue(source['guest_bookings'] ?? source['guestBookings']);
}
